Postlogin.Lesson = (function (my) {
    my.VideoSegment = function (segmentData) {
        const me = Postlogin.Lesson.Segment.apply(this, arguments);

        // Video data
        let videoKey = null;
        let videoType = null; // Animation, Cluster Overview, Job Shadow
        let videoLoaded = false;
        let playWhenLoaded = false;
        let hasError = false;
        let completionTimer = null;
        let segmentContainer;
        me.aspect_ratio = '16:9';

        let firstPlayTime = 0;

        // Shaka player instance. All lesson videos play via the video platform
        // (DASH/Shaka); there is no Wistia fallback.
        let shakaPlayer = null;
        const manifestUrl = segmentData.video && segmentData.video.manifest_url;
        const videoToken = segmentData.video && segmentData.video.video_token;

        me.init = function () {
            videoKey = segmentData.video.video_key;
            videoType = segmentData.video.video_type;
            if (segmentData.video.aspect_ratio) {
                me.aspect_ratio = segmentData.video.aspect_ratio;
            }
            me.cc_data = segmentData.video.cc_data;

            me.renderSegment();
        };

        me.renderSegment = function () {
            segmentContainer = $('<div></div>')
                .addClass(`future segment-container segment-type-${me.segment_type}`)
                .attr('id', `segment-${me.segment_index}`)
                .attr('data-segment-id', me.segment_id);
            const segmentWrapper = $('<div></div>').addClass('segment-wrapper');
            const aspectWrapper = $('<div></div>').addClass('aspect-wrapper');

            const videoEl = $('<video class="shaka-video" playsinline></video>');
            aspectWrapper.append(videoEl).append('<div class="loading-overlay"></div>');

            if (videoType === 'Job Shadow' || videoType === 'Cluster Overview') {
                segmentWrapper.addClass('frame-container');

                const frameContent = $('<div></div>').addClass('frame-content');
                frameContent.append(aspectWrapper);

                const frameOverlay = $('<div></div>').addClass('frame-overlay');
                if (me.aspect_ratio === '4:3') {
                    segmentWrapper.addClass('aspect-4-3');
                    frameOverlay.append(
                        `<img src="${Jr.getStaticImagesPath()}/beep-9-frame-4x3.png" alt="Beep-9 frame overlay" class="beep-9-overlay-layer">`,
                    );
                } else {
                    frameOverlay.append(
                        `<img src="${Jr.getStaticImagesPath()}/beep-9-frame-16x9.png" alt="Beep-9 frame overlay" class="beep-9-overlay-layer">`,
                    );
                }
                segmentWrapper.append(frameOverlay);
                segmentWrapper.append(frameContent);
            } else {
                segmentWrapper.append(aspectWrapper);
            }

            if (videoType === 'Job Shadow' && +Jr.getLicenseSetting('lessons_allow_skip_job_shadow_videos') !== 0) {
                segmentWrapper.append('<a href="#" class="skip-video">Skip Video</a>');
            }

            segmentContainer.append(segmentWrapper);
            $('#page-container').append(segmentContainer);

            initShakaPlayer();
        };

        // Shared completion handling: exit any managed fullscreen mode, hide
        // captions, then fade out and advance.
        const handleVideoEnded = function () {
            if (
                (Postlogin.Lesson.isInFullscreenMode()
                    && !Postlogin.Lesson.isInF11FullscreenMode()
                    && !Postlogin.Lesson.isInDoubleFullscreenMode()
                    && !Postlogin.Lesson.isInPlatformFullscreenMode())
                || (Postlogin.Lesson.isInFullscreenMode()
                    && Postlogin.Lesson.isInDoubleFullscreenMode()
                    && Postlogin.Lesson.isInPlatformFullscreenMode())
                // Fullscreen entered via the lesson's platform button sets
                // fullscreen + platform but not double; without this branch the
                // next segment stays fullscreen after a video ends.
                || (Postlogin.Lesson.isInFullscreenMode()
                    && Postlogin.Lesson.isInPlatformFullscreenMode()
                    && !Postlogin.Lesson.isInDoubleFullscreenMode()
                    && !Postlogin.Lesson.isInF11FullscreenMode())
            ) {
                Postlogin.Lesson.toggleFullScreen();
                Postlogin.Lesson.toggleFullScreen();
                Postlogin.Lesson.toggleFullScreen();
            }

            $('#cc-container').removeClass('shown');

            if (videoType === 'Job Shadow' || videoType === 'Cluster Overview') {
                $(`#segment-${me.segment_index} .shaka-video`).fadeOut();
                // Defer completion until the fade finishes. hide() cancels this
                // if the user navigates away, so leaving (even and returning to
                // the same segment) never fires a stale complete/advance.
                completionTimer = setTimeout(() => {
                    completionTimer = null;
                    me.setCompleted();
                    me.advance();
                }, 1000);
            } else {
                me.setCompleted();
                me.advance();
            }
        };

        // Show an error state in place of the player when the video cannot be
        // loaded. Job Shadow videos are skippable, so surface the skip link;
        // otherwise let the user advance so a bad video never traps the lesson.
        const showVideoError = function () {
            hasError = true;
            if (shakaPlayer) {
                shakaPlayer.destroy();
                shakaPlayer = null;
            }
            const aspectWrapper = $(`#segment-${me.segment_index} .aspect-wrapper`);
            aspectWrapper.find('.shaka-video').remove();
            aspectWrapper.find('.loading-overlay').fadeOut();
            aspectWrapper.append(
                '<div class="video-error">This video is currently unavailable.</div>',
            );
            // Only reveal Next if this segment is the one on screen; otherwise
            // me.show() re-asserts it when the user reaches this segment.
            if (me.segment_id === Postlogin.Lesson.getCurrentSegmentId()) {
                Postlogin.Lesson.showNextButton();
            }
        };

        // --- Shaka player ---

        const initShakaPlayer = function () {
            if (!manifestUrl) {
                console.error('No manifest_url for video segment', videoKey);
                showVideoError();
                return;
            }

            shaka.polyfill.installAll();

            if (!shaka.Player.isBrowserSupported()) {
                console.error('Shaka Player not supported in this browser');
                showVideoError();
                return;
            }

            const videoElement = document.querySelector(`#segment-${me.segment_index} .shaka-video`);
            if (!videoElement) {
                showVideoError();
                return;
            }

            shakaPlayer = new shaka.Player();
            // Runtime playback failures (expired token, rejected media segment)
            // surface via the player 'error' event, not the load() promise below.
            // Without this, playback stalls with hasError=false and Next stays
            // disabled. Ignore errors once the player has been torn down
            // intentionally (shakaPlayer nulled by showVideoError/destroy).
            shakaPlayer.addEventListener('error', (event) => {
                if (!shakaPlayer || hasError) {
                    return;
                }
                console.error('Shaka playback error', event && event.detail);
                showVideoError();
            });
            shakaPlayer.attach(videoElement).then(() => {
                if (videoToken) {
                    shakaPlayer.getNetworkingEngine().registerRequestFilter((type, request) => {
                        request.headers.Authorization = `Bearer ${videoToken}`;
                    });
                }

                // Lesson segments have their own play/pause/next/mute buttons in
                // #segment-controls, so only add Shaka's seek bar here (not its
                // full button row) to avoid a second, conflicting set of controls.
                // The seek bar itself is gated on the assignment's fast-forward
                // setting -- the same data-playbar-enabled attribute the old
                // Wistia player's `playbar` option read directly. Staff preview
                // pages (preview.php / preview-segment.php) have no assignment
                // and never render this attribute at all, so only an explicit
                // 'false' disables the seek bar; anything else (including
                // absent) defaults to enabled.
                const playbarEnabled = $('#page-container').attr('data-playbar-enabled') !== 'false';
                const uiOverlay = new shaka.ui.Overlay(shakaPlayer, videoElement.parentElement, videoElement);
                uiOverlay.configure({
                    controlPanelElements: [],
                    addSeekBar: playbarEnabled,
                });

                return shakaPlayer.load(manifestUrl);
            }).then(() => {
                videoLoaded = true;
                $(`#segment-${me.segment_index} .loading-overlay`).fadeOut();

                videoElement.addEventListener('ended', handleVideoEnded);

                videoElement.addEventListener('pause', () => {
                    me.paused = true;
                    Postlogin.Lesson.setPlayState(false);
                });

                videoElement.addEventListener('play', () => {
                    if (+firstPlayTime === 0) {
                        firstPlayTime = Date.now();
                    }
                    me.paused = false;
                    videoElement.muted = !Postlogin.Lesson.soundEnabled();
                    Postlogin.Lesson.setPlayState(true);
                });

                videoElement.addEventListener('timeupdate', () => {
                    if (me.segment_id !== Postlogin.Lesson.getCurrentSegmentId()) {
                        me.hide();
                    }
                    if ($('body').hasClass('show-menu')) {
                        me.pause();
                    }
                    if (Postlogin.Lesson.closedCaptioningEnabled() && me.cc_data != null && me.cc_data.length > 0) {
                        $('#cc-container').closedCaptioner('updateTime', videoElement.currentTime * 1000);
                    }
                });

                // Only autoplay if this segment is still the one on screen; the
                // user may have navigated away while the manifest was loading.
                if (playWhenLoaded && me.segment_id === Postlogin.Lesson.getCurrentSegmentId()) {
                    me.play();
                } else {
                    playWhenLoaded = false;
                }
            }).catch((err) => {
                console.error('Shaka load error', err);
                showVideoError();
            });
        };

        // --- Public API ---

        me.show = function () {
            me.setup();

            // Video failed to load: setup() just disabled Next, so re-enable it
            // here (the segment can't play, and the user must be able to advance).
            if (hasError) {
                Postlogin.Lesson.showNextButton();
                return;
            }

            const videoElement = document.querySelector(`#segment-${me.segment_index} .shaka-video`);
            if (videoLoaded && videoElement) {
                videoElement.currentTime = 0;
                me.play();
            } else {
                playWhenLoaded = true;
            }

            if (!me.last && me.completed) {
                Postlogin.Lesson.showNextButton();
            }

            if (me.cc_data != null && me.cc_data.length > 0) {
                $('#cc-container').closedCaptioner({
                    data: me.cc_data,
                    render: Postlogin.Lesson.renderClosedCaptioning,
                });
            }
        };

        me.hide = function () {
            // Cancel any pending end-of-video completion so navigating away
            // during the fade never advances a segment the user has left.
            if (completionTimer !== null) {
                clearTimeout(completionTimer);
                completionTimer = null;
            }
            me.pause();
            me.breakdown();
        };

        me.mute = function (sound) {
            const videoElement = document.querySelector(`#segment-${me.segment_index} .shaka-video`);
            if (videoElement) videoElement.muted = !sound;
        };

        me.replay = function () {
            // Cancel any pending end-of-video completion so replaying during the
            // fade doesn't let a stale timer advance the segment mid-replay.
            if (completionTimer !== null) {
                clearTimeout(completionTimer);
                completionTimer = null;
            }
            const videoElement = document.querySelector(`#segment-${me.segment_index} .shaka-video`);
            if (videoElement) videoElement.currentTime = 0;
            me.play();
        };

        me.play = function () {
            const videoElement = document.querySelector(`#segment-${me.segment_index} .shaka-video`);
            if (videoElement && videoElement.paused) {
                if (videoType === 'Job Shadow' || videoType === 'Cluster Overview') {
                    $(`#segment-${me.segment_index} .shaka-video`).fadeIn();
                }
                // Set muted state before play(): browsers block autoplay of
                // unmuted media without a user gesture, so an unmuted play()
                // here (segment auto-advance / initial load) is rejected and the
                // video never starts. Apply the user's sound preference first,
                // and if play still rejects, retry muted so playback proceeds —
                // then restore the intended sound once playback has started
                // (unmuting a playing element is allowed even when an unmuted
                // autoplay start was not), so audio isn't stuck off until the
                // user manually toggles mute.
                const wantSound = Postlogin.Lesson.soundEnabled();
                videoElement.muted = !wantSound;
                const playPromise = videoElement.play();
                if (playPromise && typeof playPromise.catch === 'function') {
                    playPromise.catch(() => {
                        videoElement.muted = true;
                        videoElement.play().then(() => {
                            videoElement.muted = !wantSound;
                        }).catch((err) => {
                            console.error('Video play blocked', err);
                        });
                    });
                }
                return true;
            }

            return false;
        };

        me.pause = function () {
            const videoElement = document.querySelector(`#segment-${me.segment_index} .shaka-video`);
            if (videoElement && !videoElement.paused) {
                videoElement.pause();
                return true;
            }
            if (!videoElement) {
                playWhenLoaded = false;
                return true;
            }

            return false;
        };

        return me;
    };

    return my;
}(Postlogin.Lesson || {}));
